import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import Layout from "../components/Layout";
import { FaEdit, FaTrash, FaEye } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";

const Suppliers = () => {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);

    const [showModal, setShowModal] = useState(false);
    const [editId, setEditId] = useState(null);

    const [openMenu, setOpenMenu] = useState(null);

    const [form, setForm] = useState({
        company: "",
        name: "",
        designation: "",
        phone: "",
        alternativePhone: "",
        address: "",
        email: ""
        // status: "Stock In"
    });

    const designationOptions = ["Manager", "Staff", "Assistant", "Secretary"];

    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, []);

    // RESET PAGE
    useEffect(() => {
        setPage(1);
    }, [search, limit]);

    const fetchData = async () => {
        try {
            const res = await API.get("/suppliers");
            setData(res.data);
        } catch (err) {
            toast.error("Fetch failed");
        }
    };

    // VIEW
    const viewSupplier = (s) => {
        navigate(`/supplier-items/${s._id}`, {
            state: { company: s.company }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (editId) {
                await API.put(`/suppliers/${editId}`, form);
                toast.success("Updated");
            } else {
                await API.post("/suppliers", form);
                toast.success("Created");
            }

            setShowModal(false);
            setEditId(null);
            setForm({
                company: "",
                name: "",
                designation: "",
                phone: "",
                alternativePhone: "",
                address: "",
                email: ""
            });

            fetchData();
        } catch (err) {
            toast.error("Something went wrong");
        }
    };

    const handleDelete = async (id, index) => {
        if (!window.confirm("Delete?")) return;

        try {
            await API.delete(`/suppliers/${id}/${index}`);
            toast.success("Deleted");
            fetchData();
        } catch {
            toast.error("Delete failed");
        }
    };

    const handleEdit = (supplier, index) => {

        const person = supplier.designations[index];

        setForm({
            company: supplier.company || "",
            name: person.name || "",
            designation: person.role || "",
            phone: person.phone || "",
            alternativePhone:
                person.alternativePhone || "",
            address: person.address || "",
            email: person.email || "",
            designationIndex: index
        });

        setEditId(supplier._id);

        setShowModal(true);
    };

    // /////////////////viewSupplier page//////////////////
    const toggleMenu = (id) => {
        setOpenMenu(openMenu === id ? null : id);
    };

    // ///////////////////filter///////////////
    const filtered = data.filter((d) => {

        const company = d.company || "";

        // all designation names
        const designationNames =
            d.designations
                ?.map((x) => x.name || "")
                .join(" ")
                .toLowerCase() || "";

        return (
            company.toLowerCase().includes(search.toLowerCase()) ||
            designationNames.includes(search.toLowerCase())
        );
    });

    const perPage = Number(limit);
    const start = (page - 1) * perPage;
    const current = filtered.slice(start, start + perPage);
    const totalPages = Math.ceil(filtered.length / perPage);

    return (
        <Layout>
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="topbar">
                <h2>Suppliers</h2>
                <button className="add-btn" onClick={() => setShowModal(true)}>
                    + Add Supplier
                </button>
            </div>

            <div className="table-section">

                {/* SEARCH + LIMIT */}
                <div className="table-controls">
                    <div>
                        Show
                        <select value={limit} onChange={(e) => setLimit(e.target.value)}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                        </select>
                        entries
                    </div>

                    <input
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                {/* TABLE */}
                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Company Name</th>
                                <th>Name</th>
                                <th>Designation</th>
                                <th>Phone</th>
                                <th>Alternative Number</th>
                                <th>Address</th>
                                <th>Email</th>
                                <th>Date</th>
                                <th>Actions</th>
                            </tr>
                        </thead>

                        <tbody>

                            {current.map((supplier, index) => (

                                supplier.designations?.map((person, personIndex) => (

                                    <tr key={`${supplier._id}-${personIndex}`}>

                                        {/* SERIAL NUMBER */}
                                        {personIndex === 0 && (
                                            <td rowSpan={supplier.designations.length}>
                                                {start + index + 1}
                                            </td>
                                        )}

                                        {/* COMPANY */}
                                        {personIndex === 0 && (
                                            <td rowSpan={supplier.designations.length}>
                                                {supplier.company}
                                            </td>
                                        )}

                                        {/* NAME */}
                                        <td>
                                            {person.name || "-"}
                                        </td>

                                        {/* DESIGNATION */}
                                        <td>
                                            {person.role || "-"}
                                        </td>

                                        {/* PHONE */}
                                        <td>
                                            {person.phone || "-"}
                                        </td>

                                        {/* ALT PHONE */}
                                        <td>
                                            {person.alternativePhone || "-"}
                                        </td>

                                        {/* ADDRESS */}
                                        <td>
                                            {person.address || "-"}
                                        </td>

                                        {/* EMAIL */}
                                        <td>
                                            {person.email || "-"}
                                        </td>

                                        {/* DATE */}
                                        {personIndex === 0 && (
                                            <td rowSpan={supplier.designations.length}>
                                                {
                                                    supplier.createdAt
                                                        ? new Date(
                                                            supplier.createdAt
                                                        ).toLocaleDateString(
                                                            "en-IN",
                                                            {
                                                                day: "2-digit",
                                                                month: "short",
                                                                year: "numeric"
                                                            }
                                                        )
                                                        : "-"
                                                }
                                            </td>
                                        )}

                                        {/* ACTION */}
                                        {personIndex === 0 && (
                                            <td rowSpan={supplier.designations.length}>

                                                <div className="action-menu">

                                                    <button
                                                        className="dot-btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleMenu(supplier._id);
                                                        }}
                                                    >
                                                        ⋮
                                                    </button>

                                                    {openMenu === supplier._id && (

                                                        <div
                                                            className="dropdown"
                                                            onClick={(e) =>
                                                                e.stopPropagation()
                                                            }
                                                        >

                                                            {/* VIEW */}
                                                            <div
                                                                className="view-btn"
                                                                onClick={() =>
                                                                    viewSupplier(supplier)
                                                                }
                                                            >
                                                                <FaEye /> View
                                                            </div>

                                                            {/* EDIT */}
                                                            <div
                                                                className="edit-btn"
                                                                onClick={() =>
                                                                    handleEdit(supplier, personIndex)
                                                                }
                                                            >
                                                                <FaEdit /> Edit
                                                            </div>

                                                            {/* DELETE */}
                                                            <div
                                                                className="delete-btn"
                                                                onClick={() =>
                                                                    handleDelete(
                                                                        supplier._id,
                                                                        personIndex
                                                                    )
                                                                }
                                                            >
                                                                <FaTrash /> Delete
                                                            </div>

                                                        </div>
                                                    )}

                                                </div>

                                            </td>
                                        )}

                                    </tr>

                                ))

                            ))}

                        </tbody>

                    </table>
                </div>

                {/* PAGINATION */}
                <div className="pagination">
                    <button disabled={page === 1} onClick={() => setPage(page - 1)}>
                        Prev
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => (
                        <button
                            key={i}
                            className={page === i + 1 ? "active" : ""}
                            onClick={() => setPage(i + 1)}
                        >
                            {i + 1}
                        </button>
                    ))}

                    <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>
                        Next
                    </button>
                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <h3>{editId ? "Edit Supplier" : "Add Supplier"}</h3>

                        <form onSubmit={handleSubmit}>
                            <input placeholder="Company Name"
                                value={form.company}
                                onChange={(e) => setForm({ ...form, company: e.target.value })} />

                            <input placeholder="Supplier Name"
                                value={form.name}
                                onChange={(e) => setForm({ ...form, name: e.target.value })} required />

                            <select
                                value={form.designation}
                                onChange={(e) => setForm({ ...form, designation: e.target.value })}
                            >
                                <option value="">Select Designation</option>
                                {designationOptions.map((d, i) => (
                                    <option key={i} value={d}>{d}</option>
                                ))}
                            </select>

                            <input placeholder="Supplier Phone"
                                value={form.phone}
                                onChange={(e) => setForm({ ...form, phone: e.target.value })} required />

                            <input placeholder="Alternative Phone"
                                value={form.alternativePhone}
                                onChange={(e) => setForm({ ...form, alternativePhone: e.target.value })}
                            />

                            <input placeholder="Supplier Address"
                                value={form.address}
                                onChange={(e) => setForm({ ...form, address: e.target.value })} />

                            <input placeholder="Supplier Email"
                                value={form.email}
                                onChange={(e) => setForm({ ...form, email: e.target.value })} />

                            <div className="modal-actions">
                                <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>Cancel</button>
                                <button type="submit">{editId ? "Update" : "Create"}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default Suppliers;